import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const plans = [{
  name: 'Starter',
  price: '$99',
  period: '/month',
  features: ['500 included calls', 'Basic call answering', 'Business hours support', 'Email notifications', 'Basic analytics'],
  featured: false
}, {
  name: 'Professional',
  price: '$199',
  period: '/month',
  features: ['1,500 included calls', 'Advanced call handling', '24/7 support', 'Appointment scheduling', 'Lead qualification', 'CRM integration'],
  featured: true
}, {
  name: 'Enterprise',
  price: 'Custom',
  period: '',
  features: ['Unlimited calls', 'Custom AI training', 'Dedicated support', 'Multi-language support', 'Advanced analytics', 'API access'],
  featured: false
}];
export function Pricing() {
  return <section id="pricing" className="py-16 md:py-24 lg:py-32 bg-gradient-to-b from-gray-50 to-white" data-id="element-162">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8" data-id="element-163">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12 md:mb-16" data-id="element-164">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-black mb-3 md:mb-4" data-id="element-165">
            Simple, Transparent Pricing
          </h2>
          <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto px-4" data-id="element-166">
            Choose the plan that fits your business needs
          </p>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-167">
          {plans.map((plan, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} whileHover={{
          y: -8
        }} className={`relative bg-white rounded-2xl md:rounded-3xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all ${plan.featured ? 'border-2 border-indigo-500 md:scale-105' : 'border border-gray-100'}`} data-id="element-168">
              {plan.featured && <div className="absolute -top-3 md:-top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-indigo-500 to-sky-500 text-white px-4 py-1 md:px-6 md:py-1.5 rounded-full text-xs md:text-sm font-semibold" data-id="element-169">
                  Most Popular
                </div>}
              <h3 className="text-xl md:text-2xl font-bold text-black mb-3 md:mb-4" data-id="element-170">
                {plan.name}
              </h3>
              <div className="mb-4 md:mb-6" data-id="element-171">
                <span className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-indigo-600 to-sky-500 bg-clip-text text-transparent" data-id="element-172">
                  {plan.price}
                </span>
                {plan.period && <span className="text-gray-600 ml-2 text-sm md:text-base" data-id="element-173">
                    {plan.period}
                  </span>}
              </div>
              <ul className="space-y-3 md:space-y-4 mb-6 md:mb-8" data-id="element-174">
                {plan.features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-175">
                    <CheckIcon size={18} className="text-green-500 mr-2 md:mr-3 mt-0.5 flex-shrink-0 md:w-5 md:h-5" data-id="element-176" />
                    <span className="text-gray-700 text-sm md:text-base" data-id="element-177">
                      {feature}
                    </span>
                  </li>)}
              </ul>
              <motion.button whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} onClick={() => window.location.href = 'https://wellad.online/index.php/ai-voice-agent-onboarding/'} className={`w-full py-2.5 md:py-3 text-sm md:text-base rounded-full font-semibold transition-all ${plan.featured ? 'bg-black text-white hover:shadow-lg' : 'bg-gray-100 text-black hover:bg-gray-200'}`} data-id="element-178">
                {plan.price === 'Custom' ? 'Call Sales' : 'Get Started'}
              </motion.button>
            </motion.div>)}
        </div>
      </div>
    </section>;
}